import { Service } from '../Service';
export default class MaintenanceService extends Service {
    constructor(axios) {
        super(axios);
    }
}
export { MaintenanceService };
